var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faCalendarDay, faCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { t } from '../../../strings/i18n/i18n';
import styled from 'styled-components';
import { fontSizes, fontWeights, spacing } from 'syf-component-library/defaultTheme';
import theme from '../../../theme';
var BadgeContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: ", "px;\n  border-radius: 16px;\n  height: 20px;\n  background-color: ", ";\n  color: ", ";\n  min-width: ", ";\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: ", "px;\n  border-radius: 16px;\n  height: 20px;\n  background-color: ", ";\n  color: ", ";\n  min-width: ", ";\n"])), spacing.small, function (_a) {
    var $status = _a.$status;
    switch ($status) {
        case 'POSTED':
            return theme.colors.limeGreen;
        case 'PENDING':
        default:
            return theme.colors.hoverBlue;
    }
}, function (_a) {
    var $status = _a.$status;
    switch ($status) {
        case 'POSTED':
            return theme.colors.greenText;
        case 'PENDING':
        default:
            return theme.colors.denimBlue;
    }
}, function (_a) {
    var $status = _a.$status;
    switch ($status) {
        case 'POSTED':
            return '76px';
        case 'PENDING':
        default:
            return '84px';
    }
});
var BadgeIcon = styled(FontAwesomeIcon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: ", "px;\n"], ["\n  font-size: ", "px;\n"])), fontSizes.small);
var BadgeLabel = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-left: ", "px;\n  font-size: ", "px;\n  font-weight: ", ";\n"], ["\n  margin-left: ", "px;\n  font-size: ", "px;\n  font-weight: ", ";\n"])), spacing.xsmall, fontSizes.small, fontWeights.semiBold);
var StatusIcon = {
    PENDING: faCalendarDay,
    POSTED: faCheck
};
var TransactionStatusBadge = function (_a) {
    var status = _a.status;
    var StatusText = {
        PENDING: t('questionnaire.pending'),
        POSTED: t('questionnaire.posted')
    };
    var statusText = StatusText[status];
    var statusIcon = StatusIcon[status];
    if (!statusText || !statusIcon) {
        return null;
    }
    return (_jsxs(BadgeContainer, __assign({ "data-cy": "transaction-status-badge", "$status": status }, { children: [_jsx(BadgeIcon, { icon: statusIcon }), _jsx(BadgeLabel, __assign({ "$status": status }, { children: statusText }))] })));
};
export default TransactionStatusBadge;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map